import { mapActions, mapState } from "vuex";

export default {
    computed: {
        ...mapState("components", ["raw"])
    },
    methods: {
        ...mapActions("components", ["getRawDataModel", "getRawCoreAPIs", "getRawExternalAPIs", "getRawSystemVariables",
            "getSystemVariablesForTasksExport", "getSystemVariablesForInstancesExport"]),
        parseCatalogsRawData() {
            const catalogs = {};
            const parseFields = (data, parentFields, parent) => {
                data.forEach(field => {
                    const { name, isList, fields, ...details } = field;
                    let { type } = field;

                    if (name) {
                        const key = `${parent}.${name}`;
                        if (!type) {
                            this.$store.commit("components/addIssue", `Field ${name} had no type, defaulted to String`);
                            type = "String";
                        }
                        parentFields[name] = {
                            key, type, fields: null, isList, _details: { ...details }
                        };
                        if (fields && fields.length) {
                            parentFields[name].fields = {};
                            parseFields(fields, parentFields[name].fields, key);
                        }
                    } else {
                        this.$store.commit("components/addIssue", `Unknown catalog field ${JSON.stringify(field)}`);
                    }
                });
            };

            return new Promise(resolve => {
                if (this.raw.dataModel.hasOwnProperty("modelCatalogs")) {
                    this.raw.dataModel.modelCatalogs.forEach(catalog => {
                        const { name, fields, ...details } = catalog;
                        if (name) {
                            if (catalogs.hasOwnProperty(name)) {
                                this.$store.commit("components/addIssue", `Duplicate catalog entry: ${name}`);
                            } else if (fields && fields.length) {
                                const key = name;
                                catalogs[name] = { key, fields: {}, _details: { ...details } };
                                parseFields(fields, catalogs[name].fields, key);
                            } else {
                                this.$store.commit("components/addIssue", `Catalog ${name} had no fields and was skipped`);
                            }
                        } else {
                            this.$store.commit("components/addIssue", `Unknown catalog ${JSON.stringify(catalog)}`);
                        }
                    });
                }

                this.$store.commit("components/parsedCatalogData", catalogs);
                resolve();
            });
        },
        parseModelClassesRawData(showIndex) {
            const modelClasses = {};
            const parseFields = (data, parentFields, parent) => {
                data.forEach(field => {
                    const { name, isList, fields, ...details } = field;
                    let { type } = field;

                    if (name) {
                        const key = `${parent}.${name}`;
                        if (!type) {
                            this.$store.commit("components/addIssue", `Field ${name} had no name, defaulted with String`);
                            type = "String";
                        }

                        parentFields[name] = {
                            key, type, fields: null, isList, _details: { ...details }
                        };

                        if (fields && fields.length) {
                            parentFields[name].fields = {};
                            if (showIndex && parentFields[name].isList) {
                                parentFields[name].fields._index = {
                                    fields: null,
                                    isList: false,
                                    key: `${parentFields[name].key}._index`,
                                    type: "integer"
                                };
                            }
                            parseFields(fields, parentFields[name].fields, key);
                        }
                    }
                });
            };

            return new Promise(resolve => {
                if (this.raw.dataModel.modelClasses && this.raw.dataModel.modelClasses.length) {
                    this.raw.dataModel.modelClasses.forEach(modelClass => {
                        const { name, fields, ...details } = modelClass;
                        if (name) {
                            if (modelClasses.hasOwnProperty(name)) {
                                this.$store.commit("components/addIssue", `Duplicate model class entry: ${name}`);
                            } else if (fields && fields.length) {
                                const key = name;
                                modelClasses[name] = { key, fields: {}, _details: { ...details } };
                                parseFields(fields, modelClasses[name].fields, key);
                            } else {
                                this.$store.commit("components/addIssue", `Class ${name} had no fields and was skipped`);
                            }
                        } else {
                            this.$store.commit("components/addIssue", `Unknown model ${JSON.stringify(modelClass)}`);
                        }
                    });
                }

                this.$store.commit("components/parsedModelClassesData", modelClasses);
                resolve();
            });
        },
        parsePathMethodsRequest(parameters, requestList, start = "") {
            (parameters || []).forEach(entry => {
                if (entry !== null) {
                    const path = (start ? `${start}.` : "") + entry.name;
                    const requestEntry = {
                        name: entry.name, path, type: entry.type, isList: entry.isList
                    };

                    if (entry.fields && entry.fields.length) {
                        this.parsePathMethodsRequest(entry.fields, requestList, path === "object" ? "" : path);
                    } else {
                        requestList.push(requestEntry);
                    }
                }
            });
        },
        parsePathMethodsResponse(returns, responseList, start = "") {
            (returns || []).forEach(entry => {
                if (entry) {
                    const path = (start ? `${start}.` : "") + entry.name;
                    const responseEntry = {
                        name: entry.name, path, type: entry.type, isList: entry.isList
                    };

                    if (entry.fields && entry.fields.length) {
                        this.parsePathMethodsResponse(entry.fields, responseList, path === "object" ? "" : path);
                    } else {
                        responseList.push(responseEntry);
                    }
                }
            });
        },
        parsePathMethods(methods, storeObject, apiName, apiPath) {
            (methods || []).forEach(method => {
                if (!storeObject.hasOwnProperty(method.path)) {
                    storeObject[method.path] = { request: [], response: [], apiPath };
                    if (method.parameters && method.parameters.length) {
                        this.parsePathMethodsRequest(method.parameters, storeObject[method.path].request);
                    }
                    if (method.returns && method.returns.length) {
                        this.parsePathMethodsResponse(method.returns, storeObject[method.path].response);
                    }
                }
            });
        },
        parseAPIsRawData(rawData) {
            return new Promise(resolve => {
                const apiMethods = {}; const
                    { paths } = rawData;

                paths.forEach(path => {
                    if (!apiMethods.hasOwnProperty(path.name)) {
                        apiMethods[path.name] = {};
                        this.parsePathMethods(path.methods, apiMethods[path.name], path.name, path.path);
                    }
                });

                this.$store.commit("components/parsedAPIsRawData", apiMethods);
                resolve();
            });
        },
        depthSystemVariablesParse(variablesList, storeObject, start = "") {
            variablesList.forEach(entry => {
                const entryNode = {};

                if (start) {
                    const path = (start ? `${start}.` : "") + entry.id;

                    entryNode.key = path;
                    entryNode.type = entry.hasOwnProperty("type") ? entry.type : false;
                    entryNode.notificationOnly = entry.hasOwnProperty("notificationOnly") && entry.notificationOnly;
                    entryNode.isList = entry.hasOwnProperty("isList") ? entry.isList : false;
                    entryNode.fields = null;
                    if (entry.fields && entry.fields.length) {
                        entryNode.fields = {};
                        this.depthSystemVariablesParse(entry.fields, entryNode.fields, path);
                        if (Object.keys(entryNode.fields).length) {
                            storeObject[entry.name] = entryNode;
                        }
                    } else {
                        storeObject[entry.name] = entryNode;
                    }
                } else if (entry.fields && entry.fields.length) {
                    entryNode.key = entry.name;
                    entryNode.fields = {};
                    this.depthSystemVariablesParse(entry.fields, entryNode.fields, entryNode.key);
                    if (Object.keys(entryNode.fields).length) {
                        storeObject[entry.name] = { ...entryNode };
                    }
                }
            });
        },
        parseSystemVariables(rawData) {
            const { modelVariables } = rawData; const
                systemVariables = {};
            if (modelVariables && modelVariables.length) {
                this.depthSystemVariablesParse(modelVariables, systemVariables);
            }
            this.$store.commit("components/setSystemVariablesData", systemVariables);
        }
    }
};
